<div class="sc-dd">
  <span class="custom-select-box-container">
    <span id="login-select" class="custom-select-box">
      <span class="blocker"></span>
      <span class="arrow"></span>
      <span class="selected">My Southern Cross</span>
      <span class="ul">
        <span class="li select" data-btnclass="sc-dd-mysc" data-url="https://my.southerncross.co.nz/">
          My Southern Cross</span
        >
        <span
          class="li"
          data-btnclass="sc-dd-ag"
          data-url="https://advisers.southerncross.co.nz/For-advisers/Adviser-Gateway-login">
          Adviser Gateway</span
        >
        <span class="li" data-btnclass="sc-dd-ec" data-url="https://easyclaim.southerncross.co.nz"> Easy-Claim</span>
        <span class="li" data-btnclass="sc-dd-pw" data-url="https://providers.southerncross.co.nz/login.aspx">
          Provider Web</span
        >
        <span
          class="li"
          data-btnclass="sc-dd-wsg"
          data-url="https://workscheme.southerncross.co.nz/For-employers/Login">
          Work Scheme Gateway</span
        >
      </span>
    </span>
  </span>
  <a id="btn-sc-dd-login" href="https://my.southerncross.co.nz/" class="btn" target="_blank">Log in</a>
</div>
